module.exports = __webpack_public_path__ + "img/01.ba441c5e.jpg";